import React, { useState } from "react";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import { useRef } from "react";
import { formatHumansBs } from "../../helpers/formatHuman";
import classnames from "classnames";
import { BrowserRouter as Router } from "react-router-dom";
import DescripcionDetalle from "./DescripcionDetalle";
import { getImage } from "../../helpers";
import {
    MDBBtn,
    MDBCol,
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBNav,
    MDBNavItem,
    MDBNavLink,
    MDBRow,
    MDBTabContent,
    MDBTabPane,
} from "mdbreact";
import url from "../config/Config";
import { toast, ToastContainer } from "react-toastify";
// import './toast.css';
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useParams  } from 'react-router-dom';

const buttonStyle = {
    position: "absolute",
    top: "40%",
    transform: "translateY(-50%)",
    zIndex: 2,
    padding: "10px",
    background: "none",
    border: "0px",
    fontSize: "24px",
    color: "white",
    cursor: "pointer",
};



const ModalProductoDetalle = ({
    modalProductDetails,
    setModalProductDetail,
    dataProductDetail,
    product,
}) => {
    const slideRef = useRef(null);
    const [selectCuotas, setSelectCuotas] = useState(3);
    const [activeTabs, setActiveTabs] = useState({
        activeItem1: 1,
    });
    const [currentSlide, setCurrentSlide] = useState(0);
    const [cantidad, setCantidad] = useState(1);
    const [isMobile, setIsMobile] = useState(url.isMobileDevice());

    const { bookId, nombrec } = useParams();// Id categoría

    const goToSlide = (index) => {
        if (slideRef.current) {
            slideRef.current.goTo(index);
            setCurrentSlide(index);
        }
    };
    const toggle = (tabsNum) => (tab) => (e) => {
        const key = `activeItem${tabsNum}`;
        if (activeTabs[key] !== tab) {
            setActiveTabs((prev) => ({
                ...prev,
                [key]: tab,
            }));
        }
    };
    const properties = {
        prevArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, left: "10px" }}>
                <i className="fas fa-chevron-left"></i>
            </button>
        ),
        nextArrow: isMobile ? null : (
            <button style={{ ...buttonStyle, right: "10px" }}>
                <i className="fas fa-chevron-right"></i>
            </button>
        ),
    };
    const onValueChanged = (value) => {
        if (cantidad + value < 1) return;
        setCantidad(cantidad + value);
    };
    function AgregarCarrito(e, producto) {
        e.preventDefault();
        const { nombre, imagen, stock, precio, idproducto } = producto;

        if (parseInt(stock) === 0) {
            toast.warn("No hay suficientes unidades", {
                autoClose: 3000,
                position: "top-right",
            });
            return;
        }

        const objProductCarrito = {
            idprod: idproducto,
            nombrep: nombre,
            cantidad: 1,
            imagen: imagen,
            precio: precio,
        };
        let carrito = JSON.parse(localStorage.getItem("CarritoJucumari")) ?? [];

        const existProduct = carrito.some(
            (carritoState) => carritoState.idprod === objProductCarrito.idprod
        );

        if (existProduct) {
            carrito = carrito.map((carritoState) =>
                carritoState.idprod === objProductCarrito.idprod
                    ? {
                          ...carritoState,
                          cantidad:
                              carritoState.cantidad +
                              objProductCarrito.cantidad,
                      }
                    : carritoState
            );
        } else {
            carrito.push(objProductCarrito);
        }

        localStorage.setItem("CarritoJucumari", JSON.stringify(carrito));
        window.dispatchEvent(new Event("storage"));

        toast.success("Producto agregado a su carrito", {
            autoClose: 3000,
            position: "top-right",
        });

        setModalProductDetail(!modalProductDetails);
    }
    const mensajeWhatsappApi = `Queria más información del producto ${product.nombre} \n`;
    let urlLocal = `${mensajeWhatsappApi } `;
    if( bookId ) 
        urlLocal += ` http://localhost:3000/categoria/${bookId}/${nombrec}/1?e=luxhogar&producto=${product.idproducto}`;
    const enlace = `https://api.whatsapp.com/send?phone=59175095058&text=${encodeURIComponent(urlLocal)}`;

    return (
        <>
            <ToastContainer
                hideProgressBar={true}
                newestOnTop={true}
                autoClose={5000}
            />
            <MDBModal
                size="lg"
                isOpen={modalProductDetails}
                toggle={() => {
                    setModalProductDetail(!modalProductDetails);
                }}
                className="m-0 modal-margin"
            >
                <MDBModalBody className="py-3 px-2 lg:p-8">
                        <div className="text-end pr-3">
                             <span
                                className="cursor-pointer"
                                onClick={() => setModalProductDetail(!modalProductDetails)}
                            >
                                <i className="fas fa-times text-2xl text-black"></i>
                            </span>
                        </div>
                    <div className="lg:flex">
                        <MDBCol size="12" sm="12" lg="6">
                            <div className="mb-2">
                                {dataProductDetail.images &&
                                    dataProductDetail.images.length > 0 && (
                                        <Slide
                                            ref={slideRef}
                                            easing="ease"
                                            autoplay={true}
                                            arrows={!isMobile}
                                            indicators={isMobile}
                                            {...properties}
                                        >
                                            {dataProductDetail.images.map(
                                                (img, i) => (
                                                    <div
                                                        className="each-slide"
                                                        key={i}
                                                    >
                                                        <div
                                                            className="overflow-hidden w-full h-[300px] lg:h-[400px]"
                                                        >
                                                            <img
                                                                src={getImage(
                                                                    img.path
                                                                )}
                                                                alt={`slide-${i}`}
                                                                className="object-cover w-full h-full"
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </Slide>
                                    )}
                                {
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: "10px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {dataProductDetail.images &&
                                            dataProductDetail.images.length >
                                                0 &&
                                            dataProductDetail.images.map(
                                                (img, i) => (
                                                    <div
                                                        key={i}
                                                        className={`border-b-4 ${
                                                            currentSlide === i
                                                                ? "border-b-black"
                                                                : "border-transparent"
                                                        }`}
                                                    >
                                                        <img
                                                            key={i}
                                                            src={getImage(
                                                                img.path
                                                            )}
                                                            alt={`thumb-${i}`}
                                                            style={{
                                                                width: "80px",
                                                                height: "50px",
                                                                objectFit:
                                                                    "cover",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                                goToSlide(i)
                                                            }
                                                        />
                                                    </div>
                                                )
                                            )}
                                    </div>
                                }
                            </div>
                        </MDBCol>
                        <MDBCol size="12" sm="12" lg="6">
                            <div className="relative w-full">
                                <h3 className="text-xl font-bold lg:text-3xl max-w-72">
                                    {product.nombre}
                                </h3>
                                <span className="absolute top-0 right-0">
                                    <i className="fas fa-heart text-xl text-gray-400 hover:text-red-500 cursor-pointer"></i>
                                </span>
                            </div>
                            <div className="space-y-4">
                                <div className="flex items-center justify-between my-4">
                                    <p className="text-lg lg:text-xl text-gray-400 line-through font-semibold">
                                        {formatHumansBs(
                                            (
                                                product.precio -
                                                (product.decuento / 100) *
                                                    product.precio
                                            ).toFixed(2)
                                        )}
                                    </p>
                                    <p className="font-bold text-xl lg:text-3xl">
                                        {formatHumansBs(product.precio)}
                                    </p>
                                </div>
                                <div className="flex items-center justify-between gap-4">
                                    <p>
                                        {product.decuento != 0 && <></>}
                                        <span className="rounded-md p-1 bg-red-600 text-white font-semibold">
                                            - 10%
                                        </span>
                                    </p>
                                    <div className="flex gap-3">
                                        <span
                                            className="rounded-full font-bold py-1 px-4 bg-gray-200"
                                            onClick={() => onValueChanged(+1)}
                                        >
                                            +
                                        </span>
                                        <span>{cantidad}</span>
                                        <span
                                            className="rounded-full font-bold py-1 px-4 bg-gray-400"
                                            onClick={() => onValueChanged(-1)}
                                        >
                                            -
                                        </span>
                                    </div>
                                </div>

                                <div className="flex items-center justify-between">
                                    <select
                                        name=""
                                        id=""
                                        className="py-1 px-6 bg-white border border-none rounded-md"
                                        value={selectCuotas}
                                        onChange={(e) =>
                                            setSelectCuotas(e.target.value)
                                        }
                                    >
                                        <option value="3">3 cuotas</option>
                                        <option value="6">6 cuotas</option>
                                        <option value="9">9 cuotas</option>
                                    </select>
                                    <p className="text-gray-500 font-semibold text-lg">
                                        <span className="font-bold text-gray-600">
                                            {formatHumansBs(
                                                product.precio / selectCuotas
                                            )}
                                        </span>
                                    </p>
                                </div>
                                <div className="flex flex-col gap-1 mb-2">
                                    <div className="flex items-center p-3 gap-2 border border-gray-100 rounded-lg">
                                        <span className="">
                                            <i className="fas fa-store"></i>
                                        </span>
                                        <div>
                                            <h2 className="font-bold text-lg">
                                                Recoger en Tienda
                                            </h2>
                                            <p>
                                                <span className="bg-green-200 text-sm p-1 font-semibold rounded-md">
                                                    Disponible
                                                </span>{" "}
                                                <span className="font-normal text-base">
                                                    en 10 sucursales
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex items-center p-3 gap-2 border border-gray-100 rounded-lg">
                                        <span className="">
                                            <i className="fas fa-shopping-cart"></i>
                                        </span>
                                        <div>
                                            <h2 className="font-bold text-lg">
                                                Enviar a domicilio
                                            </h2>
                                            <p>
                                                <span className="bg-green-200 text-sm p-1 font-semibold rounded-md">
                                                    Disponible
                                                </span>{" "}
                                                <span className="font-normal text-base">
                                                    en 10 sucursales
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                                <button
                                    style={{
                                        padding: "0",
                                        margin: "0",
                                        height: "auto",
                                    }}
                                    type="button"
                                    className="rounded-full font-semibold text-white block w-full py-2 px-3 text-center bg-tertiary-personalize"
                                    onClick={(e) => AgregarCarrito(e, product)}
                                >
                                    Agregar al carrito{" "}
                                    <i className="fas fa-shopping-cart"></i>
                                </button>
                                <div className="mb-2 flex items-center gap-2">
                                    <span className="text-gray-600">Compartir</span>
                                    <span className="bg-blue-800 h-9 w-9 flex items-center justify-center rounded-sm">
                                        <i className="fab fa-facebook-f text-center text-xl text-white"></i>
                                    </span>
                                    <span className="bg-green-800 h-9 w-9 flex items-center justify-center rounded-sm">
                                        <a href={`${enlace}`} target="_blank" rel="noopener">
                                            <i className="fab fa-whatsapp text-xl text-white"></i>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </MDBCol>
                    </div>
                    <Router>
                        <MDBContainer className="my-4">
                            <MDBNav pills className="nav-justified ">
                                <MDBNavItem className="">
                                    <MDBNavLink
                                        link
                                        to="#!"
                                        className={` ${classnames({
                                            "bg-tertiary-personalize text-white":
                                                activeTabs.activeItem1 === 1,
                                            "border-2 text-black":
                                                activeTabs.activeItem1 !== 1,
                                        })}`}
                                        onClick={toggle(1)(1)}
                                    >
                                        Descripción
                                    </MDBNavLink>
                                </MDBNavItem>
                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#!"
                                        className={classnames({
                                            "bg-tertiary-personalize text-white":
                                                activeTabs.activeItem1 === 2,
                                            "border-2 text-black":
                                                activeTabs.activeItem1 !== 2,
                                        })}
                                        onClick={toggle(1)(2)}
                                    >
                                        Datos Técnicos
                                    </MDBNavLink>
                                </MDBNavItem>
                            </MDBNav>
                            <MDBTabContent activeItem={activeTabs.activeItem1}>
                                <MDBTabPane tabId={1}>
                                    <MDBRow>
                                        <MDBCol sm="12">
                                            {dataProductDetail.caracteristicas &&
                                            dataProductDetail.caracteristicas
                                                .length > 0 ? (
                                                dataProductDetail.caracteristicas.map(
                                                    (caracteristica, index) => (
                                                        <DescripcionDetalle
                                                            key={index}
                                                            htmlTexto={
                                                                caracteristica.descripcion
                                                            }
                                                        />
                                                    )
                                                )
                                            ) : (
                                                <p>
                                                    No hay Descripción para este
                                                    producto.
                                                </p>
                                            )}
                                        </MDBCol>
                                    </MDBRow>
                                </MDBTabPane>
                                <MDBTabPane tabId={2}>
                                    <MDBRow>
                                        <MDBCol sm="12">
                                            {dataProductDetail.especificaciones &&
                                            dataProductDetail.especificaciones
                                                .length > 0 ? (
                                                dataProductDetail.especificaciones.map(
                                                    (especificacion, index) => (
                                                        <table
                                                            key={index}
                                                            className="w-full table-fixed border border-gray-300 rounded-xl border-collapse"
                                                        >
                                                            <tbody>
                                                                <tr className="bg-white hover:bg-gray-50">
                                                                    <td className="w-1/2 border border-gray-300 px-4 py-3 align-top">
                                                                        <span
                                                                            className="font-bold text-lg block text-tertiary-personalize"
                                                                        >
                                                                            {
                                                                                especificacion.descripcion
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td className="w-1/2 border border-gray-300 px-4 py-3 align-top">
                                                                        <span className="font-semibold text-gray-600">
                                                                            {
                                                                                especificacion.valor
                                                                            }
                                                                        </span>{" "}
                                                                        {
                                                                            especificacion.nombre
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    )
                                                )
                                            ) : (
                                                <p className="text-gray-500">
                                                    No hay especificaciones
                                                    técnicas para este producto.
                                                </p>
                                            )}
                                        </MDBCol>
                                    </MDBRow>
                                </MDBTabPane>
                            </MDBTabContent>
                        </MDBContainer>
                    </Router>
                </MDBModalBody>
            </MDBModal>
        </>
    );
};

export default ModalProductoDetalle;
